import React, { Component } from "react";
import { Box, Button } from "@mui/material";
import instance from "../../axios";
import Loader from "../../Layout/Loader";
import { getCompanyById } from "../../Helpers";
import {
  BayanatDeliveryNoteMui,
  mapCustomerReceivingToDoc,
  printMuiDoc,
} from "../../Components/Documents";

let serverTimeZoneName = "";

const resolveTimezoneFromQuery = (raw) => {
  try {
    return decodeURIComponent((raw || "").split("&")[0]) || "Asia/Riyadh";
  } catch (e) {
    return (raw || "").split("&")[0] || "Asia/Riyadh";
  }
};

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data1: {},
      loader: false,
      company: null,
      didAutoPrint: false,
    };
  }

  componentWillMount() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    const queryString = window.location.search;
    const res = queryString.split("?&token=");
    const parts = (res[1] || "").split("&timezone=");
    // legacy URL also had &leasing= — strip it
    const paymentId = (parts[0] || "").split("&leasing=")[0];
    serverTimeZoneName = resolveTimezoneFromQuery(parts[1]);

    this.setState({ loader: true }, () => {
      instance({
        method: "GET",
        url: `/api/payments/${paymentId}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const raw =
            response && typeof response === "object" && !Array.isArray(response)
              ? response
              : {};
          // Support flat payment or nested { payment, account|user|customer }
          const data1 =
            raw.payment || raw.account || raw.user || raw.customer
              ? {
                  payment: raw.payment || raw,
                  account: raw.account || raw.user || raw.customer || null,
                }
              : raw;
          const payment = data1.payment || data1;
          const companyId =
            payment?.companyId || raw?.companyId || userInfo?.companyId;
          if (companyId) {
            getCompanyById(companyId)
              .then((company) => this.setState({ company }))
              .catch((error) => console.error(error.message));
          }
          this.setState({ data1, loader: false });
        })
        .catch((error) => {
          console.log("error ====", error);
          this.setState({ loader: false });
        });
    });
  }

  componentDidUpdate() {
    this.maybeAutoPrint();
  }

  replaceAmpersands(obj) {
    if (!obj || typeof obj !== "object") return;
    for (const prop in obj) {
      if (typeof obj[prop] === "string") {
        obj[prop] = obj[prop].replace(/amp;/g, "");
      } else if (typeof obj[prop] === "object" && obj[prop] !== null) {
        this.replaceAmpersands(obj[prop]);
      }
    }
  }

  buildDoc() {
    const { data1, company } = this.state;
    if (!data1 || !Object.keys(data1).length) return null;
    const data = data1;
    this.replaceAmpersands(data);
    return mapCustomerReceivingToDoc(data, company, {
      timezone: serverTimeZoneName,
    });
  }

  maybeAutoPrint() {
    const params = new URLSearchParams(window.location.search);
    const autoPrint = params.get("autoPrint");
    const { loader, data1, didAutoPrint } = this.state;
    if (
      loader ||
      !data1 ||
      !Object.keys(data1).length ||
      didAutoPrint ||
      !autoPrint
    ) {
      return;
    }
    this.setState({ didAutoPrint: true }, () => {
      const doc = this.buildDoc();
      printMuiDoc({ title: doc?.titleEn || "Customer Receiving" }).then(() => {
        window.onafterprint = () => {
          try {
            window.close();
          } catch (e) {
            // ignore
          }
        };
      });
    });
  }

  handlePrint = () => {
    const doc = this.buildDoc();
    printMuiDoc({ title: doc?.titleEn || "Customer Receiving" });
  };

  handleClose = () => {
    try {
      window.close();
    } catch (e) {
      // ignore
    }
    if (!window.closed) {
      try {
        window.history.back();
      } catch (e2) {
        // ignore
      }
    }
  };

  render() {
    const { loader, data1 } = this.state;
    if (loader || !data1 || !Object.keys(data1).length) {
      return <Loader component="filter" />;
    }
    const params = new URLSearchParams(window.location.search);
    const autoPrint = params.get("autoPrint");
    const doc = this.buildDoc();

    return (
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#e9ebf0",
          "@media print": {
            bgcolor: "#fff !important",
            backgroundColor: "#fff !important",
            minHeight: "0 !important",
          },
        }}
      >
        {!autoPrint && (
          <Box
            className="bn-toolbar"
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 20,
              width: "210mm",
              maxWidth: "100%",
              mx: "auto",
              mt: 2,
              mb: 1.5,
              px: 1.5,
              py: 1,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              bgcolor: "#fff",
              borderRadius: 1,
              boxShadow: "0 1px 6px rgba(0,0,0,.08)",
              boxSizing: "border-box",
              "@media print": { display: "none !important" },
            }}
          >
            <Button
              variant="contained"
              size="small"
              onClick={this.handlePrint}
              sx={{
                textTransform: "none",
                bgcolor: "#10b981",
                "&:hover": { bgcolor: "#0b7d57" },
              }}
            >
              Print
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={this.handleClose}
              sx={{
                textTransform: "none",
                borderColor: "#e3e6ec",
                color: "#3b4256",
              }}
            >
              Close
            </Button>
          </Box>
        )}
        <BayanatDeliveryNoteMui doc={doc} hideToolbar />
      </Box>
    );
  }
}

export default Payment;
